import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import initReactFastclick from 'react-fastclick'
import styled, { ThemeProvider, injectGlobal } from 'styled-components'
import media from 'styled-media-query'

// Components
import Headroom from 'react-headroom'
import Header from '../components/Header'
import Time from '../components/Time'
import Footer from '../components/Footer'
import '../utils/typeface.css'

initReactFastclick();

injectGlobal`
  html, body {
    -webkit-tap-highlight-color: transparent;
    background: #F9F9F9;
    height: 100%;
  }
  body > div,
  body > div > div {
    height: 100%;
  }
`;

const Layout = styled.div`
  background: ${props => props.theme.background};
  position: relative;
  height: auto;
  min-height: 100%;

  transition: background 2s ease;
  transition: color 2s ease;

  // Typography
  h1 {
    color: ${props => props.theme.color};
  }

  div, span, li, p {
    color: ${props => props.theme.p};
  }

  a {
    color: ${props => props.theme.color};

    &:hover {
      color: ${props => props.theme.hover};
    }
  }

  *::selection {
    background: ${props => props.theme.selection};
    color: ${props => props.theme.color};
  }

  &.what,
  &.who,
  &.where,
  &.why,
  &.work {
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
`;

const TemplateWrapper = ({ children, location, data }) => {
  var pathClass = location.pathname.split('/').join(' ');
  var theme;

  switch(pathClass.trim()) {
    case '':
    case 'what':
    case 'who':
    case 'where':
    case 'why':
      theme = {
        background: '#111',
        color: '#fff',
        hover: 'rgb(0,231,192)',
        selection: '#f81ce5',
        p: 'rgba(255,255,255,0.8)',
        textShadow: '#111'
      };
      break;
    default:
      theme = {
        background: '#f9f9f9',
        color: '#000',
        hover: '#ff0080',
        selection: '#79FFE1',
        p: 'rgba(0,0,0,0.8)',
        textShadow: '#f1f1f1'
      };
  }

  return (
    <div>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Portfolio of Florian Nebenfuehr.' },
          { name: 'keywords', content: 'design, development, branding, digital, florian nebenfuehr' },
        ]}>
        <meta name="viewport" content="initial-scale=1.0, width=device-width, user-scalable=no" />
      </Helmet>

      <ThemeProvider theme={theme}>
        <Layout className={pathClass}>
          <Headroom style={{zIndex: 100}}>
            <Header siteTitle={data.site.siteMetadata.title} />
            <Time />
          </Headroom>

          {children()}

          <Footer />
        </Layout>
      </ThemeProvider>
    </div>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js